import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { useAppSelector } from '../../../reducers';
import { productForSkuIdSelector } from '../../../selectors/ProductsSelectors';
import DisabledDowngradeButton from '../../../v2/components/purchase-motions/DisabledDowngradeButton';
import RedirectToCustomerPlatformButton from '../../../v2/components/purchase-motions/RedirectToCustomerPlatformButton';
import RedirectToMarketingPlusButton from '../../../v2/components/purchase-motions/RedirectToMarketingPlusButton';
import { SingleSkeletonLoader } from '../../../v2/components/SingleSkeletonLoader';
import { usePurchaseMotionOverrides } from '../../../v2/hooks/purchase-motions/usePurchaseMotionOverrides';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MerchCardCTAOverridesWrapper = ({
  skuId,
  trackingSource,
  children,
  size
}) => {
  const isAppReady = useGlobalLoading();
  const {
    apiName
  } = useAppSelector(state => {
    if (!isAppReady) {
      return {
        apiName: undefined
      };
    }
    return productForSkuIdSelector(state, {
      skuId
    });
  });
  const override = usePurchaseMotionOverrides(apiName || '');
  if (!apiName || override.loading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 40
    });
  }
  if (override.type === 'DISABLED_DOWNGRADE') {
    return /*#__PURE__*/_jsx(DisabledDowngradeButton, {
      size: size
    });
  }
  if (override.type === 'REDIRECT_MARKETING_PLUS') {
    return /*#__PURE__*/_jsx(RedirectToMarketingPlusButton, {
      trackingSource: trackingSource,
      size: size
    });
  }
  if (override.type === 'REDIRECT_CUSTOMER_PLATFORM') {
    return /*#__PURE__*/_jsx(RedirectToCustomerPlatformButton, {
      trackingSource: trackingSource,
      size: size
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export default MerchCardCTAOverridesWrapper;